import { ReactComponent as CLOSE } from "./../../../../assets/CloseICON.svg"
import BaseTableRow from "../../../../components/layout/BaseTableRow"
import BasePopover from "../../../../components/elements/BasePopover"
import { transactionElementType } from "../../types"
import { returnThousanderBreakInNumber } from "../../../../services/functions"
import dayjs from "dayjs"
import { P } from "../../../../auth/permissions"
import { Authorized } from "../../../../components/authentication/Authorized"

type TransactionTableRowType = {
    transaction: transactionElementType
    openPaymentModal: () => void
    ignoreTransaction: () => void
}

export default function TransactionTableRow(props: TransactionTableRowType) {
    return (
        <BaseTableRow
            onClick={props.openPaymentModal}
            classProps={""}>
            <td className="table-cell">
                <p className="line-clamp-1  text-center">{dayjs(props.transaction.bookingTimestamp).format("DD.MM.YYYY")}</p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1  text-center">{props.transaction.processingStatus === "UNASSIGNED" ? "Nicht zugewiesen" : props.transaction.processingStatus}</p>
            </td>
            <td className={`table-cell z-10 hover:underline`}>
                <p className={`line-clamp-1 text-center`}>
                    {returnThousanderBreakInNumber(Number(props.transaction.paymentInformation.transactionAmount.amount))} €
                </p>
            </td>
            <td>
                <p className="line-clamp-1  text-center w-full min-w-[10rem]">{props.transaction.paymentInformation.counterpartNames.join(", ")}</p>
            </td>
            <td>
                <p className="line-clamp-1 w-full min-w-[4rem] text-center">{props.transaction.paymentInformation.remittanceText}</p>
            </td>
            <Authorized allOf={[P.buchhaltung_zahlungen_read_write]}>
                <td onClick={(event) => event.stopPropagation()}>
                    <BasePopover
                        placement="bottomLeft"
                        label="Transaktion ignorieren?"
                        text="Die Transaktion wird ignoriert und nicht mehr angezeigt."
                        okButtonClick={props.ignoreTransaction}>
                        <CLOSE className="w-6 h-6 z-10 " />
                    </BasePopover>
                </td>
            </Authorized>
        </BaseTableRow>
    )
}
